import type { QueryParams, Route, Store } from 'mobx-router'
import { RouterStore, startRouter } from 'mobx-router'

export class RootRouterStore {
  public router: RouterStore<RootRouterStore>
  private routes: Record<string, Route<any, QueryParams, QueryParams>>
  private directorRouter: ReturnType<typeof startRouter>

  constructor(routes: Record<string, Route<any, QueryParams, QueryParams>>) {
    this.routes = routes
    this.router = new RouterStore<RootRouterStore>(this)
  }

  startRouter() {
    try {
      const hashValue = window.location.hash
      // the Director does not like hash values here, it will mess with them
      // So we clear the hash value before starting the router
      // clear the hash value if it exists
      if (hashValue) window.location.hash = ''
      this.directorRouter = startRouter(this.routes, this, {
        html5history: true,
      })
      console.log({ directorRouter: this.directorRouter })
      // restore the hash value if it exists
      if (hashValue) window.location.hash = hashValue
    } catch (e) {
      console.error(e)
    }
  }

  navigateToUrl(url: string) {
    window.history.pushState({}, '', url)
    this.directorRouter.handler()
  }

  navigate(to: string) {
    console.log('Navigating to:', to)
    const route = Object.values(this.routes).find((r) => r.path === to)
    if (route) {
      this.router.goTo(route)
    } else {
      console.warn(`No route found for path: ${to}`)
    }
  }

  navigateToHome = () => {
    this.router.goTo(this.routes.home)
  }

  navigateToChecklist = (id: string) => {
    this.router.goTo(this.routes.checklist, { id })
  }

  navigateToTemplate = (id: string) => {
    this.router.goTo(this.routes.template, { id })
  }

  navigateToTemplateReorder = (id: string) => {
    this.router.goTo(this.routes.templateReorder, { id })
  }

  navigateToSettings = ({ tab }: { tab?: string } = {}) => {
    this.router.goTo(this.routes.settings, undefined, { tab: tab })
  }
}
